import { yupResolver } from "@hookform/resolvers/yup";
import { PencilSimple, Trash } from "phosphor-react";
import { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import * as yup from "yup";
import ActionButton from "../../../components/ActionButton";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import ItemsList, { HeaderList, ListItem } from "../../../components/ItemsList";
import ModalAction from "../../../components/ModalAction";
import PageTitle from "../../../components/PageTitle";
import TabSwitcher from "../../../components/TabSwitcher";
import Template from "../../../components/Template";
import { adicionarRiscoGrupoTitulo, alterarRiscoGrupoTitulo, excluirRiscoGrupoTitulo, obterListaRiscoGrupoTitulo } from '../../../services/api/Configuracoes/RiscoGrupoTitulo/index';
import { IAlterarRiscoGrupoTitulo } from '../../../services/models/Configuracoes/RiscoGrupoTitulo/index';
import * as S from "../style";
import { usePermissionsStore } from "../../../stores/PermissionsStore";

const AddRiskGroupTitleSchema = yup.object({
    descricao: yup.string().required("O nome da fase é obrigatório.")
})

interface item {
    id: number;
    descricao: string;
    isAtivo: boolean;
}

const RiskGroupTitle = () => {
    const [view, setView] = useState<number>(0)
    const [RiskGroupTitleList, setRiskGroupTitleList] = useState<any>(null)

    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
    const [showEditModal, setShowEditModal] = useState<boolean>(false)
    const [itemToDelete, setItemToDelete] = useState<item | null>(null)
    const [itemToEdit, setItemToEdit] = useState<item | null>(null)

    useEffect(() => {
        view === 0 && ObterListaRiscoGrupoTitulo()
    }, [view])

    const {
        handleSubmit,
        control,
        reset,
        formState: {
            errors,
            isValid
        } } = useForm({
            mode: "onChange",
            reValidateMode: "onChange",
            resolver: yupResolver(AddRiskGroupTitleSchema)
        })

    const ObterListaRiscoGrupoTitulo = async () => {
        let res = await obterListaRiscoGrupoTitulo()
        setRiskGroupTitleList(res)
    }

    const AdicionarRiscoGrupoTitulo = async (data: any) => {
        let body = {
            ...data
        }

        await adicionarRiscoGrupoTitulo(body).then(() => {
            reset()
        })
    }

    const ExcluirRiscoGrupoTitulo = async (idRiscoGrupoTitulo: number) => {
        await excluirRiscoGrupoTitulo({ idRiscoGrupoTitulo })
        ObterListaRiscoGrupoTitulo()
    }

    const EditarRiscoGrupoTitulo = async (newRiscoGrupoTitulo: IAlterarRiscoGrupoTitulo) => {
        await alterarRiscoGrupoTitulo(newRiscoGrupoTitulo)
        ObterListaRiscoGrupoTitulo()
    }

    const handleShowDeleteModal = (item: item) => {
        setItemToDelete(item)
        setShowDeleteModal(true)
    }

    const handleShowEditModal = (item: item) => {
        setItemToEdit(item)
        setShowEditModal(true)
    }

    const findPermission = usePermissionsStore((state) => state.findPermission);

    const permissions = findPermission(5);

    // PARA TESTE
    // const permissions = {
    //     permiteInserir: false,
    //     permiteAlterar: false,
    //     permiteExcluir: false,
    // }

    const {
        permiteInserir,
        permiteAlterar,
        permiteExcluir
    } = permissions;

    const menuItems = permiteInserir ?
        [
            "Dados",
            "Adicionar"
        ] : [
            "Dados"
        ]

    const headerList = permiteAlterar || permiteExcluir ?
        [
            "Descrição",
            "Status",
            "Ações"
        ] : [
            "Descrição",
            "Status"
        ]

    return (
        <Template>
            <PageTitle>
                Risco Grupo Título
            </PageTitle>
            <TabSwitcher
                list={menuItems}
                view={view}
                setView={setView}
            />
            <S.Content>
                <S.ControlView active={view === 0}>
                    {
                        RiskGroupTitleList ? (
                            <ItemsList>
                                <HeaderList items={headerList} />
                                {
                                    RiskGroupTitleList.map((item: item, index: any) => {
                                        return (
                                            <ListItem key={index}>
                                                <div>{item.descricao}</div>
                                                <div>{item.isAtivo ? "Ativo" : "Inativo"}</div>
                                                {
                                                    (
                                                        permiteAlterar ||
                                                        permiteExcluir
                                                    ) && (
                                                        <div>
                                                            {
                                                                permiteAlterar && (
                                                                    <ActionButton act="edit" onClick={() => handleShowEditModal(item)}>
                                                                        <PencilSimple />
                                                                    </ActionButton>
                                                                )
                                                            }
                                                            {
                                                                permiteExcluir && (
                                                                    <ActionButton act="delete" onClick={() => handleShowDeleteModal(item)}>
                                                                        <Trash />
                                                                    </ActionButton>
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </ListItem>
                                        )
                                    })
                                }
                            </ItemsList>
                        ) : (<p>Carregando...</p>)
                    }
                </S.ControlView>
                <S.ControlView active={view === 1} id="addRisk" onSubmit={handleSubmit((data) => AdicionarRiscoGrupoTitulo(data))}>
                    <S.GridItem cols={2}>
                        <Input id="descricao" name="descricao" label="Descrição" control={control} error={errors?.descricao?.message} />
                    </S.GridItem>
                    {
                        isValid && (
                            <S.GridItem cols={6}>
                                <Button type="submit" form="addRisk">Adicionar</Button>
                            </S.GridItem>
                        )
                    }
                </S.ControlView>
            </S.Content>
            {
                showDeleteModal && itemToDelete && (
                    <ModalAction
                        type="delete"
                        onConfirm={() => ExcluirRiscoGrupoTitulo(itemToDelete.id)}
                        onClose={() => setShowDeleteModal(false)}
                        title="Excluir Risco Grupo Título"
                        item={itemToDelete}
                    />
                )
            }
            {
                showEditModal && itemToEdit && (
                    <ModalAction
                        type="edit"
                        onConfirm={(e) => EditarRiscoGrupoTitulo(e)}
                        onClose={() => setShowEditModal(false)}
                        title="Editar Risco Grupo Título"
                        item={itemToEdit}
                    />
                )
            }
        </Template >
    )

}

export default RiskGroupTitle